import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  // Check if the current measure is a supply measure that needs updating
  const currentMeasure = params.measure;
  const dateHierarchy = params.dateHierarchy;
  let newMeasure = currentMeasure;

  if (currentMeasure && dateHierarchy) {
    const isSupplyMeasure =
      currentMeasure.toLowerCase().includes("supply") &&
      (currentMeasure.toLowerCase().includes("starting") ||
        currentMeasure.toLowerCase().includes("ending") ||
        currentMeasure.toLowerCase().includes("target"));

    if (isSupplyMeasure) {
      // Extract the base part (starting/ending/target) and the period
      const baseMatch = currentMeasure.match(/^(Starting|Ending|Target)\s+/i);
      if (baseMatch) {
        const base = baseMatch[1];
        const period =
          dateHierarchy.charAt(0).toUpperCase() + dateHierarchy.slice(1) + "s";
        const newMeasureName = `${base} ${period} of Supply`;

        // Only update if the measure name would actually change
        if (newMeasureName !== currentMeasure) {
          console.log(
            `[InventoryHealthForHubs] Auto-updating measure from "${currentMeasure}" to "${newMeasureName}"`
          );
          // Update the measure in the params
          params.measure = newMeasureName;
        }
      }
    }
  }
  return {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: params.dateHierarchy,
    measure: newMeasure || "Starting Weeks of Supply",
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
    value_field: params.measure ?? "",
  };
};
